import { useMemo } from 'react';

import { Formik } from 'formik';

import CreateFormArray from './CreateFormArray';
import additionalInformationInitialValues from './initialValues';
import useCreateSchema from './useCreateSchema';
import { createCustomFieldInitialValues, filterInitialValues } from './util';

const CreateAdditionalInformation = ({
  participants = [],
  setIsFormValid,
  setParticipants = () => {},
  eventData = {}
}) => {
  const validationSchema = useCreateSchema(eventData?.customFields);

  const participantWithoutBookingPerson = participants.filter(
    (participant) => !participant.isBookingPerson
  );

  const initialValues = useMemo(
    () => ({
      additionalInfo: participantWithoutBookingPerson.map(
        (participant, index) =>
          participant.additionalInfo || {
            ...{
              ...filterInitialValues(additionalInformationInitialValues, eventData, index),
              customFields: createCustomFieldInitialValues(eventData?.customFields)
            },
            name: `${participant?.generalInformation?.firstName || ''} ${participant?.generalInformation?.lastName || ''}`,
            id: participant.id
          }
      )
    }),
    [participants]
  );

  const onSubmit = (values, { setSubmitting }) => {
    setParticipants((participants) =>
      participants.map((participant) => {
        const additionalInfoForParticipant = values.additionalInfo.find(
          (info) => participant.id === info.id
        );
        if (additionalInfoForParticipant) {
          return { ...participant, additionalInfo: additionalInfoForParticipant };
        } else {
          return participant;
        }
      })
    );

    setSubmitting(false);
  };

  return (
    <>
      <Formik
        validateOnMount
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ values, setValues, setFieldValue }) => {
          return (
            <>
              <CreateFormArray
                values={values}
                setIsFormValid={setIsFormValid}
                setValues={setValues}
                setFieldValue={setFieldValue}
                eventData={eventData}
              />
            </>
          );
        }}
      </Formik>
    </>
  );
};

export default CreateAdditionalInformation;
